/**
 * Contact write schema, derived from the generated Zod. See ./README.md.
 *
 * The counterpart is the PROPERTY serializer's nested contact, not
 * `ContactsCreateBody`: the webapp never calls the standalone `/contacts`
 * endpoints — a property contact is read and written through the property.
 *
 * There is no contact READ schema here. The read shape is
 * `PropertiesRetrieveResponse.shape.contact`, applied by
 * `~/data/schemas/property`, and `Contact` comes from the generated model.
 */
import { z } from 'zod';

import { PropertiesPartialUpdateBody } from '~/data/generated/zod/properties/properties.zod';

import { emptyStringToNull } from './zodHelpers';

const contactBodySchema = PropertiesPartialUpdateBody.shape.contact.unwrap().unwrap();

export const contactInputSchema = contactBodySchema.extend({
  // The edit form emits '' for a cleared field, which the API rejects; map it
  // to the null it means before the generated checks run.
  email: emptyStringToNull(contactBodySchema.shape.email),
  phone: emptyStringToNull(contactBodySchema.shape.phone),
});

export type ContactInput = z.infer<typeof contactInputSchema>;
